import { render, staticRenderFns } from "./SendListPhoneSmsModal.vue?vue&type=template&id=8b93383c"
import script from "./SendListPhoneSmsModal.vue?vue&type=script&lang=js"
export * from "./SendListPhoneSmsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports